import React, { useState } from 'react';
import { FileText, Copy, CheckCircle } from 'lucide-react';

interface SignaturePayloadBoxProps {
  payload: string;          // Payload crudo (para copiar/verificar)
  payloadPretty: string;    // Payload bonito (para mostrar)
}

const SignaturePayloadBox: React.FC<SignaturePayloadBoxProps> = ({
  payload,
  payloadPretty,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(payload);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("❌ Error al copiar:", err);
    }
  };

  return (
    <div className="mt-8 rounded-xl border border-gray-300 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-800 dark:text-white">
          <FileText className="h-5 w-5 text-primary" />
          Payload firmado
        </h3>

        <button
          onClick={handleCopy}
          className={`flex items-center gap-1 rounded-md px-3 py-1 text-sm font-medium transition-all ${
            copied
              ? 'bg-green-600 text-white hover:bg-green-700'
              : 'bg-primary text-white hover:bg-primary/90'
          }`}
        >
          {copied ? (
            <>
              <CheckCircle className="h-4 w-4" />
              Copiado
            </>
          ) : (
            <>
              <Copy className="h-4 w-4" />
              Copiar
            </>
          )}
        </button>
      </div>

      {/* 📜 Muestra la versión bonita */}
      <pre className="max-h-96 overflow-auto rounded-md bg-black/80 p-4 text-sm text-green-200 whitespace-pre-wrap">
        {payloadPretty || payload}
      </pre>
    </div>
  );
};

export default SignaturePayloadBox;
